module.exports = __webpack_public_path__ + "assets/e39fcd75eea8138e6bb32597c16aeadd.mp3";